<!-- Add Language Side Panel -->
<div class="question-side-panel">
    <div class="side-panel-overlay" (click)="closeQuestionModal()"></div>
    <div class="side-panel-container">
        <div class="side-panel-header">
            <div class="header-label"> {{(isEditMode)?'Edit Question':'Create New Question'}}</div>
            <div class="header-actions">
                <button class="usage-guide-btn"><img src="./assets/images/book-open-page-variant-outline.svg"> Usage guide</button>
                <button class="close-button" (click)="closeQuestionModal()">
                    <img src="./assets/images/close.svg">
                </button>
            </div>
        </div>

        <div class="side-panel-content">
            <!-- Main content area with editor and preview -->
            <div class="question-editor-container" *ngIf="isIntractionLoaded">
                <!-- Left side - Question editor -->
                <div class="question-editor">
                    <!-- Question category -->
                    <div class="editor-row">
                        <div class="input-group">
                            <label>Question Category</label>
                            <div class="select-wrapper">
                                <select class="form-select" id="interaction_question_type" style="text-transform: capitalize;"
                                    (ngModelChange)="onQuestionTypeChange($event); markDirty()"
                                    [disabled]="!isEditInteractionType || !isUserHasWriteAccess" [(ngModel)]="selectedQuestionType">
                                    <option *ngFor="let item of questionTypes;" style="text-transform: capitalize;"
                                        [value]="item.type">{{ item.name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="input-group">
                            <label>Rater type</label>
                            <div class="select-wrapper">
                                <select class="form-select" id="interaction_component_id" [disabled]="!isEditInteractionType || !isUserHasWriteAccess"
                                    (ngModelChange)="onComponentChange($event); markDirty()"
                                    [(ngModel)]="selectedComponentId">
                                    <option *ngFor="let component of questionComponents" [value]="component._id">
                                        {{component.display_name || component.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- Additional options -->
                    <div class="additional-options">
                        <div class="option-row">
                            <div class="format-toolbar">
                                <div class="format-group">
                                    <label>Text</label>
                                </div>
                            </div>
                            <input type="text" *ngIf="!interaction?.rich_text_enabled" (keyup)="toggleHilight($event)"
                            [disabled]="!isUserHasWriteAccess"
                                [class.error-hilight]="!isQuestionTextAvailable" id="interaction_question_text"
                                placeholder="Enter your question here..." [(ngModel)]="interaction.text"
                                class="short-text-input question-text" (change)="updateGroupTextInSubQuestion()" (ngModelChange)="markDirty()">
                            <div class="text-editor-area" [class.error-hilight]="!isQuestionTextAvailable"
                                *ngIf="interaction?.rich_text_enabled">
                                <quill-editor [disabled]="!isUserHasWriteAccess" [style]="{height: '120px',width:'100%'}"
                                    (onEditorChanged)="toggleHilight($event)" (onContentChanged)="contentChanged($event)" id="interaction_question_text"
                                    [(ngModel)]="interaction.rich_text" placeholder="Enter your question here..."
                                    (ngModelChange)="markDirty()"></quill-editor>
                            </div>
                            <label class="checkbox-container">
                                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.rich_text_enabled"
                                    (ngModelChange)="markDirty()">
                                <span class="checkmark"></span>
                                Enable Rich Text
                            </label>
                            <div class="option-description">
                                Enable this option to allow users to format the question using simple styles like bold text, lists, and links.
                            </div>
                        </div>

                        <div class="option-row">
                            <label class="checkbox-container">
                                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.is_short_text_enabled" (ngModelChange)="markDirty()">
                                <span class="checkmark"></span>
                                Short text for dashboard
                            </label>
                            <div class="option-description">
                                Enable this option to add a brief label that is displayed on the dashboard for quick and easy identification.
                            </div>
                            <input type="text" [disabled]="!isUserHasWriteAccess || !interaction.is_short_text_enabled" [(ngModel)]="interaction.question" placeholder="Enter short text here..."
                                class="short-text-input" (ngModelChange)="markDirty()">
                        </div>

                        <div class="option-row">
                            <label class="checkbox-container">
                                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.is_displayed_on_dashboard"
                                    (ngModelChange)="markDirty()">
                                <span class="checkmark"></span>
                                Visibility on the dashboard
                            </label>
                            <div class="option-description">
                                Control whether this question appears on the dashboard for reporting and viewing
                            </div>
                            <!-- <div class="visibility-options" *ngIf="selectedComponent?.type == 'rating'">
                                <input type="checkbox" id="display_on_summary"
                                    [(ngModel)]="interaction.is_displayed_on_summary" (ngModelChange)="markDirty()">
                                <label class="visibility-button" [class.active]="interaction.is_displayed_on_summary"
                                    for="display_on_summary">Score</label>
                            </div> -->
                        </div>
                    </div>
                </div>

                <!-- Right side - Preview section -->
                <div class="question-preview">
                    <div class="preview-header">
                        <div class="device-toggle">
                            <button class="device-button" [ngClass]="{'active': currentDevice === 'desktop'}"
                                (click)="setDeviceView('desktop')">
                                <img src="./assets/images/desktop.svg" alt="Desktop" class="device-icon" />
                                Desktop
                            </button>
                            <button class="device-button" [ngClass]="{'active': currentDevice === 'mobile'}"
                                (click)="setDeviceView('mobile')">
                                <img src="./assets/images/mobile.svg" alt="Mobile" class="device-icon" />
                                Mobile
                            </button>
                            <button class="device-button" [ngClass]="{'active': currentDevice === 'tablet'}"
                                (click)="setDeviceView('tablet')">
                                <img src="./assets/images/tablet.svg" alt="Tablet" class="device-icon" />
                                Tablet
                            </button>
                        </div>
                    </div>

                    <div class="preview-container" style="background: transparent;">
                        <!-- Mobile preview -->
                        <div class="mobile-preview" [ngClass]="{'active': currentDevice === 'mobile'}">
                            <div class="mobile-frame">
                                <div class="mobile-content">
                                    <div style="width: 100%;height: 100%;">
                                        <img style="width: 100%;height: 100%;"
                                            [src]="getComponentImage(selectedComponent?.name)"
                                            (error)="getComponentImage()" alt="No Image Preview Available"
                                            class="ltms-interaction-edit-component-selection-{{currentDevice}}-img">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Desktop preview -->
                        <div class="desktop-preview" [ngClass]="{'active': currentDevice === 'desktop'}">
                            <div class="desktop-frame">
                                <!-- <div class="desktop-header">
                        <div class="desktop-header-dot"></div>
                        <div class="desktop-header-dot"></div>
                        <div class="desktop-header-dot"></div>
                    </div> -->
                                <div class="desktop-content">
                                    <div style="width: 100%;height: 100%;">
                                        <img style="width: 100%;height: 100%;"
                                            [src]="getComponentImage(selectedComponent?.name)"
                                            (error)="getComponentImage()" alt="No Image Preview Available"
                                            class="ltms-interaction-edit-component-selection-{{currentDevice}}-img">
                                    </div>
                                </div>
                            </div>
                            <div class="desktop-stand"></div>
                        </div>

                        <!-- Tablet preview -->
                        <div class="tablet-preview" [ngClass]="{'active': currentDevice === 'tablet'}" [style]="{}">
                            <div class="tablet-frame">
                                <div class="tablet-content">
                                    <div style="display: flex;justify-content: center;width: 100%;height: 100%;">
                                        <img style="width: 100%;height: 100%;"
                                            [src]="getComponentImage(selectedComponent?.name)"
                                            (error)="getComponentImage()" alt="No Image Preview Available"
                                            class="ltms-interaction-edit-component-selection-{{currentDevice}}-img">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Properties section -->
            <div class="properties-section" *ngIf="isIntractionLoaded">
                <div class="properties-header">
                    <h3>Properties</h3>
                    <button class="toggle-button" (click)="togglePropertiesPanel()">
                        <i class="fa" [ngClass]="isPropertiesPanelOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                </div>

                <div class="properties-content" *ngIf="isPropertiesPanelOpen">
                    <p class="properties-description">
                        Configure how the question is displayed, answered, and used for reporting within the conversation.
                    </p>

                    <!-- Tab buttons for Basic/Advanced -->
                    <div class="tab-buttons">
                        <button class="tab-button" *ngIf="interaction.component_type !='litmus-text-label'"
                            [ngClass]="{'active': activePropertyTab === 'basic'}"
                            (click)="setPropertyTab('basic')">Basic</button>
                        <button class="tab-button" [ngClass]="{'active': activePropertyTab === 'advanced'}"
                            (click)="setPropertyTab('advanced')">Advanced</button>
                    </div>

                    <!-- Basic properties options -->
                    <div class="properties-options" *ngIf="interaction.component_type !='litmus-text-label'"
                        [class.show]="activePropertyTab === 'basic'">
                        <!-- Display in conversation option -->
                        <div class="property-item">
                            <div class="property-content">
                                <div class="property-title">Do you want to display the Question text in the
                                    conversation?</div>
                                <div class="property-description">Control whether the question text is shown to users during the conversation.</div>
                            </div>
                            <div class="property-toggle">
                                <label class="switch">
                                    <input type="checkbox" [disabled]="!isUserHasWriteAccess" (ngModelChange)="toggleLabelVisiblity()"
                                        [(ngModel)]="displayLabel">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>

                        <!-- Mandatory question option -->
                        <div class="property-item">
                            <div class="property-content">
                                <div class="property-title">Do you want to make this Question Mandatory?</div>
                                <div class="property-description">Ensure the respondent must answer this question before moving forward.</div>
                            </div>
                            <div class="property-toggle">
                                <label class="switch">
                                    <input type="checkbox" [(ngModel)]="interaction.is_mandatory"
                                        [disabled]="interaction.is_primary_rating || !isUserHasWriteAccess" (ngModelChange)="markDirty()">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>

                        <!-- Primary question option -->
                        <div class="property-item"
                            *ngIf="selectedComponent?.type == 'rating' && !interaction?.isPrimaryQuestionSet  && selectedComponent?.name !== 'ltms-cookie-counter'">
                            <div class="property-content">
                                <div class="property-title">Do you want to make this Question the Primary Question?
                                </div>
                                <div class="property-description">Set this question as the primary reference for reporting and analytics.</div>
                            </div>
                            <div class="property-toggle">
                                <label class="switch">
                                    <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.is_primary_rating"
                                        (ngModelChange)="checkForPrimaryRating($event,'is_primary_rating')">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>

                        <div class="property-item"
                        *ngIf="selectedComponent?.type == 'rating'">
                            <div class="property-content">
                                <div class="property-title">Display in Trends Tab?
                                </div>
                                <div class="property-description">
                                    Enable this to include the question in Trends Tab
                                </div>
                            </div>
                            <div class="property-toggle">
                                <label class="switch">
                                    <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.is_displayed_on_summary"
                                        (ngModelChange)="checkForTrendsTab($event,'is_displayed_on_summary')">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>

                        <!--  Primary comment option-->
                        <div class="property-item"
                            *ngIf="interaction?.component_type=='ltms-text-area' || interaction?.component_id=='586c8fe88eabb824403e2cf7'|| selectedComponent?.can_be_set_as_primary_comment">
                            <div class="property-content">
                                <div class="property-title">Do you want to make this Question the Primary Comment?</div>
                                <div class="property-description">Use responses from this question as the main comment shown across dashboards and reports.</div>
                            </div>
                            <div class="property-toggle">
                                <label class="switch">
                                    <input type="checkbox" [(ngModel)]="interaction.is_primary_comment"
                                        [disabled]="interaction.is_primary_comment || !isUserHasWriteAccess"
                                        (ngModelChange)="checkForPrimaryRating($event,'is_primary_comment')">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>

                        <!-- calculate mean option -->
                        <div class="property-item"
                            *ngIf="interaction?.main_rater_type == 3 || interaction?.main_rater_type == 10 || showCalculateMean">
                            <div class="property-content">
                                <div class="property-title">Do you want to calculate mean?</div>
                                <div class="property-description">Enable average score calculation for this question in dashboards and reports.</div>
                            </div>
                            <div class="property-toggle">
                                <label class="switch">
                                    <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.is_calculate_mean_enabled"
                                        (ngModelChange)="markDirty()">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>

                        <!-- Include reactor option -->
                        <div class="property-item" *ngIf="selectedComponent?.rating_bar_reactor_allowed">
                            <div class="property-content">
                                <div class="property-title">Do you want to include reactor?</div>
                                <div class="property-description">Allow respondents to add quick reactions (such as emojis) to the question.</div>
                            </div>
                            <div class="property-toggle">
                                <label class="switch">
                                    <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.rating_bar_reactor_allowed"
                                        (ngModelChange)="markDirty()" (change)="setReactorType(interaction.rating_bar_reactor_allowed)">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                        <div class="property-item" *ngIf="interaction?.rating_bar_reactor_allowed">
                            <div class="property-content">
                                <div class="property-title">Select a reactor from list to add.</div>
                            </div>
                            <div class="property-toggle-dropdown">
                                <div class="select-wrapper">
                                    <select class="form-select" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.reactor_type"
                                        (ngModelChange)="markDirty()">
                                        <!-- <option value="">Select reactor</option> -->
                                        <option value="ltms-rating-text-reactor">Text Reactor</option>
                                        <option value="ltms-rating-bubble-reactor">Bubble Reactor</option>
                                        <option value="ltms-rating-color-reactor">Bar Reactor</option>
                                    </select>
                                    <span class="select-arrow"></span>
                                </div>
                            </div>
                        </div>

                        <!-- use for update information option -->
                        <div class="property-item"
                            *ngIf="selectedComponent?.name == 'ltms-input'||selectedComponent?.name == 'litmus-input'">
                            <div class="property-content">
                                <div class="property-title">Do you want to use this to update user information?</div>
                                <div class="property-description">Use responses from this question to update user profile details.</div>
                            </div>
                            <div class="property-toggle">
                                <label class="switch">
                                    <input type="checkbox" [(ngModel)]="interaction.is_user_info"
                                        (ngModelChange)="toggelIsUserInfo($event,interaction)">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                        <div class="property-item"
                            *ngIf="!interaction?.is_primary_rating && !interaction?.is_primary_comment && interaction?.is_user_info">
                            <div class="property-content">
                                <div class="property-title">User Information to Update <span
                                        class="text-danger">*</span></div>
                            </div>
                            <div class="property-toggle-dropdown">
                                <div class="select-wrapper">
                                    <select class="form-select" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.user_info_type"
                                        (ngModelChange)="markDirty()">
                                        <option value=''>Select</option>
                                        <option value='name'>Name</option>
                                        <option value='phone_number'>Phone Number</option>
                                        <option value='email_address'>Email Address</option>
                                        <option value='tag_gender'>Gender</option>
                                        <option value='tag_dob'>Date of Birth</option>
                                        <option value='other'>Other</option>
                                    </select>
                                    <span class="select-arrow"></span>
                                </div>
                            </div>
                        </div>
                        
                        <ng-container
                            *ngIf=" (selectedComponent && selectedComponent?.component_category == 'multi-select') && ((selectedComponent && selectedComponent?.name == 'ltms-multi-check-box') || interaction.question_component_type == 'ltms-multi-check-box' || interaction.component_category == 'multi-select') "
                            id="childInteractionsList">
                            <div class="property-item" *ngIf="!selectedComponent?.is_allow_multi_select_display">
                                <div class="property-content">
                                    <div class="property-title">Do you want to allow Multi Select?</div>
                                    <div class="property-description">Allow users to choose more than one option for this question.</div>
                                </div>
                                <div class="property-toggle">
                                    <label class="switch">
                                        <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="interaction.allowMultiSelect"
                                            (click)="invokeShuffling()" (ngModelChange)="markDirty()">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="property-item">
                                <div class="property-content">
                                    <div class="property-title">Do you want to enable Parent-Child Linkage?</div>
                                    <div class="property-description">Show follow-up options based on the option selected in this question.</div>
                                </div>
                                <div class="property-toggle">
                                    <label class="switch">
                                        <input type="checkbox" [disabled]="!isUserHasWriteAccess" name="enableParentChildLinkage"
                                            [(ngModel)]="interaction.enableParentChildLinkage"
                                            (click)="handleMultipleParentChild(interaction.enableParentChildLinkage)"
                                            (ngModelChange)="markDirty()">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="property-item" *ngIf="interaction.allowMultiSelect">
                                <div class="property-content">
                                    <div class="property-title">Do you want to enable Conditional Labels?</div>
                                    <div class="property-description">Show different labels based on user responses or conditions.</div>
                                </div>
                                <div class="property-toggle">
                                    <label class="switch">
                                        <input type="checkbox" [disabled]="!isUserHasWriteAccess" name="enableConditionalLabels"
                                            [(ngModel)]="interaction.enableConditionalLabels"
                                            (click)="enableConditionalLabelOption()" (ngModelChange)="markDirty()">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="property-item" *ngIf="interaction.allowMultiSelect">
                                <div class="property-content">
                                    <div class="property-title">Do you want to setup Advanced Conditions on Each Option?
                                    </div>
                                    <div class="property-description">Define conditions that control the visibility or behavior of individual options.</div>
                                </div>
                                <div class="property-toggle">
                                    <label class="switch">
                                        <input type="checkbox" [disabled]="!isUserHasWriteAccess" name="setupOptions"
                                            [(ngModel)]="interaction.setupOptions" (ngModelChange)="markDirty()">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="property-item" *ngIf="interaction.allowMultiSelect">
                                <div class="property-content">
                                    <div class="property-title">Do you want to Enable Shuffle?</div>
                                    <div class="property-description">Once enabled options do not appear in the same fixed sequence for all users.</div>
                                </div>
                                <div class="property-toggle">
                                    <label class="switch">
                                        <input type="checkbox" [disabled]="!isUserHasWriteAccess" name="enableShuffle"
                                            [(ngModel)]="interaction.enable_shuffle" (ngModelChange)="markDirty()">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="property-item">
                                <div class="property-content">
                                    <div class="property-title">Add Options <span class="text-danger">*</span></div>
                                </div>
                                <div class="option-list-wrapper" style="width: 50%; min-width: 320px;" cdkDropList [cdkDropListDisabled]="!isUserHasWriteAccess" (cdkDropListDropped)="onSubQuestionDrop($event)">
                                    <div class="option-item"
                                        *ngFor="let question of interaction.sub_questions; let indx = index" cdkDrag>
                                        <span class="option-drag-handle" cdkDragHandle>
                                            <i class="fa fa-bars"></i>
                                        </span>
                                        <input type="text" class="option-input" [disabled]="!isUserHasWriteAccess" [(ngModel)]="question.text"
                                            placeholder="Option {{ indx + 1 }}" (ngModelChange)="markDirty()" />
                                        <button type="button" class="option-remove-btn" [disabled]="!isUserHasWriteAccess"
                                            (click)="removeSubQuestionFromInteraction(indx, question.field_id, $event)"
                                            aria-label="Remove option">
                                            <i class="fa fa-times"></i>
                                        </button>
                                        <div class="shuffle-option" *ngIf="interaction.enable_shuffle">
                                            <div class="property-toggle">
                                                <label class="switch">
                                                    <input type="checkbox" [disabled]="!isUserHasWriteAccess" name="enableShuffle"
                                                        [(ngModel)]="question.enable_shuffle" (ngModelChange)="markDirty()">
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                            <div class="property-content">
                                                <div class="property-title">Enable Shuffle</div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="option-add-btn-row">
                                        <button type="button" class="option-add-btn" [disabled]="!isUserHasWriteAccess"
                                            (click)="addSubQuestionForInteraction()">
                                            Add Option
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <!-- Advanced properties options -->
                    <div class="properties-options" [class.show]="activePropertyTab === 'advanced'">
                        <div #componentSchema id="componentSchema"></div>
                    </div>
                </div>
            </div>

            <!-- Conditions section -->
            <div class="conditions-section" *ngIf="isIntractionLoaded">
                <div class="conditions-header">
                    <h3>Conditions</h3>
                    <button class="toggle-button" (click)="toggleConditionsPanel()">
                        <i class="fa" [ngClass]="isConditionsPanelOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                </div>

                <div class="conditions-content" *ngIf="isConditionsPanelOpen">
                    <p class="conditions-description">
                        Configure conditions to control when this question should be displayed or made mandatory based
                        on other
                        question responses.
                    </p>

                    <!-- Tab buttons for Visibility/Mandatory -->
                    <div class="tab-buttons">
                        <button class="tab-button" *ngIf="interactionCount>1"
                            [ngClass]="{'active': activeConditionTab === 'visibility'}"
                            (click)="setConditionTab('visibility')">Visibility</button>
                        <button class="tab-button" *ngIf="interactionCount>1"
                            [ngClass]="{'active': activeConditionTab === 'mandatory'}"
                            (click)="setConditionTab('mandatory')">Mandatory</button>
                        <button class="tab-button" [ngClass]="{'active': activeConditionTab === 'custom'}"
                            (click)="setConditionTab('custom')">Custom</button>
                    </div>

                    <!-- Visibility conditions and  Mandatory conditions-->
                    <div class="conditions-options"
                        [class.show]="(activeConditionTab === 'visibility'|| activeConditionTab === 'mandatory') && interactionCount>1">
                        <div class="condition-item">
                            <div class="condition-content">
                                <div class="condition-title">Show this question when</div>
                                <div class="condition-description">Set conditions for when this question should be {{(
                                    activeConditionTab === 'mandatory')?'mandatory':'displayed'}} </div>
                            </div>
                            <div class="condition-builder" [class.edit-mode]="logic.isEditMode"
                                *ngFor="let logic of componentConditions.logicDetail[componentConditions.logicAction].transformString;let index = index;first as isFirst">
                                <div *ngIf="!isFirst"
                                    class="margin-bottom-10 margin-top-10 condition-logical-operators">
                                    <div id="outer" style="width:100%">
                                        <div id="inner" class="btn-group" role="group">
                                            <button type="button" class="btn btn-default _btn-default"
                                                *ngFor="let operator of operators.logical;" ng-model='logic.logicalOptr'
                                                (click)='logic.logicalOptr = operator.op;'
                                                [disabled]="!isUserHasWriteAccess"
                                                [ngClass]="logic.logicalOptr == operator.op ? 'btn btn-primary btn-condition' : 'btn btn-default'"
                                                (ngModelChange)="markDirty()">
                                                {{operator.text}}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="logic.isValid" class="row condition-container">
                                    <div class="col col-11 question-condition">
                                        <span *ngIf="logic.target === 'target_value'">
                                            {{getInteractionText(logic.interaction)}}
                                            <span style="color: black;font-weight: 600;">
                                                {{operatorsMap[logic.comparisonOptr]['text']||logic.comparisonOptr}}
                                            </span>
                                            {{logic.value.toString() || logic.value}}
                                        </span>
                                        <span *ngIf="logic.target === 'target_field'">
                                            {{getInteractionText(logic.interaction)}}
                                            <span style="color: black;font-weight: 600;">
                                                {{operatorsMap[logic.comparisonOptr]['text']||logic.comparisonOptr}}
                                            </span>
                                            <span>
                                                {{getInteractionText(logic.targetInteraction)}}
                                            </span>
                                        </span>
                                    </div>
                                    <div class="col col-1 action-button-group">
                                        <a class="studio-condition-edit-button" *ngIf="!logic.isEditMode"
                                            (click)="isUserHasWriteAccess && openEditContainer(logic,index,logic.configuration)" [style.pointer-events]="isUserHasWriteAccess ? 'auto' : 'none'" [style.opacity]="isUserHasWriteAccess ? 1 : 0.5">
                                            <img
                                                src="https://static1.litmusworld.com/studio-resources/png/circle-edit-outline/circle-edit-outline.png" />
                                        </a>
                                        <a class="studio-condition-edit-button" data-toggle="modal"
                                            (click)="isUserHasWriteAccess && closeCondition(index)">
                                            <img
                                                src="https://static1.litmusworld.com/studio-resources/png/trash-can-outline/trash-can-outline.png" />
                                        </a>
                                    </div>
                                </div>

                                <div *ngIf="logic.isOpen" class="condition-group">
                                    <div class="select-wrapper">
                                        <select class="form-select condition-select" [disabled]="!isUserHasWriteAccess" [(ngModel)]="logic.interaction"
                                            (ngModelChange)="updateTransitionObject(index, logic, componentConditions.logicAction)">
                                            <option value="">Select question</option>
                                            <ng-container *ngFor="let question of questionsAndGroups;">
                                                <option [value]="question?.field_id"
                                                    *ngIf="isQuestion(question) && question?.field_id">
                                                    {{question?.text}}
                                                </option>
                                                <optgroup [label]="question?.text"
                                                    *ngIf="isQuestionGroup(question) && question?.field_id">
                                                    <option [value]="opt.field_id"
                                                        *ngFor="let opt of question?.options">
                                                        {{opt.text}}</option>
                                                </optgroup>
                                            </ng-container>
                                        </select>
                                    </div>
                                    <div class="select-wrapper">
                                        <select class="form-select" [disabled]="!isUserHasWriteAccess || !logic.interaction" [(ngModel)]="logic.comparisonOptr">
                                            <option value="">Select operator</option>
                                            <option [value]="operator.op" *ngFor="let operator of operators.comparison">
                                                {{operator.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="select-wrapper">
                                        <select class="form-select condition-select" [disabled]="!isUserHasWriteAccess || !logic.comparisonOptr" [(ngModel)]="logic.target">
                                            <option value="">Select Target</option>
                                            <option value="target_value">Value</option>
                                            <option value="target_field">Question</option>
                                        </select>
                                    </div>
                                    <div class="select-wrapper">
                                        <select class="form-select condition-select"
                                            *ngIf="!logic.target || logic.target == 'target_value'"
                                            [disabled]="!isUserHasWriteAccess || !logic.target" [(ngModel)]="logic.value" required>
                                            <option value="">Select value</option>
                                            <option *ngFor="let config of logic.configuration" [value]="config.value">
                                                {{ config.label}} ({{config.value}})
                                            </option>
                                        </select>
                                        <select class="form-select condition-select" *ngIf="logic.target=='target_field'"
                                            [disabled]="!isUserHasWriteAccess || !logic.target" [(ngModel)]="logic.targetInteraction" required>
                                            <option value="">Select value</option>
                                            <ng-container *ngFor="let question of questionsAndGroupsForOptions;">
                                                <option [value]="question?.field_id"
                                                    *ngIf="isQuestion(question) && question?.field_id">
                                                    {{question?.text}}
                                                </option>
                                                <optgroup [label]="question?.text"
                                                    *ngIf="isQuestionGroup(question) && question?.field_id">
                                                    <option [value]="opt.field_id"
                                                        *ngFor="let opt of question?.options">
                                                        {{opt.text}}({{opt?.field_id}})</option>
                                                </optgroup>
                                            </ng-container>
                                        </select>
                                    </div>
                                    <button class="add-condition-btn" [disabled]="!isUserHasWriteAccess" (click)="addCondition(logic)">
                                        <i class="fa fa-plus" *ngIf="!logic.isEditMode"></i>
                                        {{(logic.isEditMode)?'Update':'Add'}}
                                    </button>
                                    <button class="add-condition-btn" *ngIf="!logic.isEditMode" [disabled]="!isUserHasWriteAccess"
                                        (click)="closeCondition(index)">
                                        clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Custom conditions -->
                    <div class="conditions-options" [class.show]="activeConditionTab === 'custom'">
                        <div class="custom-condition-card">
                            <div class="custom-condition-header">
                                <div class="custom-condition-title">
                                    <span>Make this question mandatory when</span>
                                    <span class="custom-condition-info"
                                        title="Write a custom logical expression using field IDs and operators. E.g., rating.detailed_rating['field_id'] == 'value'">
                                        <i class="fa fa-info-circle"></i>
                                    </span>
                                </div>
                                <div class="custom-condition-description">
                                    Set conditions for when this question should be mandatory using a custom expression.
                                </div>
                            </div>
                            <div class="custom-condition-body">
                                <label class="custom-expression-label">Provide Custom Expression</label>
                                <textarea class="custom-expression-textarea" [disabled]="!isUserHasWriteAccess"
                                    placeholder="E.g. rating.detailed_rating['field_id'] == 'value'"
                                    [(ngModel)]="componentConditions.logicDetail['3'].logicString"
                                    (blur)="updateCurrentCondition(3)" name="serverVisible" rows="3"
                                    (ngModelChange)="updateCurrentCondition(3)"></textarea>
                                <!-- <div class="custom-condition-actions">
                                    <button class="custom-save-btn" type="button" (click)="updateCurrentCondition(3)">
                                        <i class="fa fa-save"></i> Save
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Parent Child Linkage section -->
            <div class="conditions-section" *ngIf="isIntractionLoaded && interaction.enableParentChildLinkage">
                <div class="conditions-header">
                    <h3>Parent Child Linkage</h3>
                    <button class="toggle-button" (click)="toggleAccordianPanel('parentChildLinkage')">
                        <i class="fa" [ngClass]="accordians['parentChildLinkage'] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                </div>

                <div class="conditions-content" *ngIf="accordians['parentChildLinkage']">
                    <app-interaction-parent-child-linkage [interaction]="interaction"
                        [readOnly]="!isUserHasWriteAccess"
                        (onChange)="parentLinkingChanged($event)"></app-interaction-parent-child-linkage>
                </div>
            </div>

            <!-- Conditional Labels section -->
            <div class="conditions-section"
                *ngIf="isIntractionLoaded && interaction.enableConditionalLabels && interaction.allowMultiSelect">
                <div class="conditions-header">
                    <h3>Conditional Labels</h3>
                    <button class="toggle-button" (click)="toggleAccordianPanel('conditionalLabels')">
                        <i class="fa" [ngClass]="accordians['conditionalLabels'] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                </div>

                <div class="conditions-content" *ngIf="accordians['conditionalLabels']">
                    <app-interaction-conditional-labels [interaction]="interaction"
                        [readOnly]="!isUserHasWriteAccess"
                        (onChange)="updateQuestion($event)"></app-interaction-conditional-labels>
                </div>
            </div>

            <!-- Setup Options  section -->
            <div class="conditions-section"
                *ngIf="isIntractionLoaded && interaction.setupOptions && interaction.allowMultiSelect">
                <div class="conditions-header">
                    <h3>Setup Options</h3>
                    <button class="toggle-button" (click)="toggleAccordianPanel('setupOptions')">
                        <i class="fa" [ngClass]="accordians['setupOptions'] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                </div>

                <div class="conditions-content" *ngIf="accordians['setupOptions']">
                    <app-interaction-setup-options [interaction]="interaction"
                        [readOnly]="!isUserHasWriteAccess"
                        (onChange)="updateQuestion($event)"></app-interaction-setup-options>
                </div>
            </div>

            <div *ngIf="!isIntractionLoaded">
                <app-ltms-loader></app-ltms-loader>
            </div>
        </div>

        <div class="side-panel-footer">
            <button class="btn-cancel" (click)="closeQuestionModal()">Cancel</button>
            <button class="btn-save" id="saveInteractionButton" (click)="saveInteraction()" [disabled]="!isDirty || !isUserHasWriteAccess">
                {{(isEditMode)?'Update':'Save'}}
            </button>
        </div>
    </div>
</div>